import {
  OfferType,
  printDebugLog
} from "../constants/constant";

export const calculateBillTotal = ({
  prevTotalPrice = 0.0, // total price (item*quantity) before adding new item
  newTotalPrice = 0.0,   // total price (item*quantity) after adding new item
  billTotalPrice = 0.0,
  cgstRate = 0.0,
  sgstRate = 0.0,
  pointRedeem = 0.0,
  isGstAllowed = false,
  deliveryCharge = 0.0,
  offerType = OfferType.No_Offer,
  offerValue = 0.0,
  isPartialBillEnabled = false,
}) => {
  const parsedValues = {
    prevTotalPrice: parseFloat(prevTotalPrice) || 0.0,
    newTotalPrice: parseFloat(newTotalPrice) || 0.0,
    pointRedeem: parseFloat(pointRedeem) || 0.0,
    deliveryCharge: parseFloat(deliveryCharge) || 0.0,
    offerValue: parseFloat(offerValue) || 0.0,
    cgstRate: parseFloat(cgstRate) || 0.0,
    sgstRate: parseFloat(sgstRate) || 0.0,
    billTotalPrice: parseFloat(billTotalPrice) || 0.0,
  };
console.log("parsedValues: ", parsedValues);
printDebugLog("::calculateBillTotal::isGstAllowed: ", isGstAllowed);

  const subTotal = parsedValues.billTotalPrice + parsedValues.newTotalPrice - parsedValues.prevTotalPrice;
  let total = subTotal;

  switch (parseInt(offerType)) {
    case OfferType.Flat:
      total -= parsedValues.offerValue;
      break;
    case OfferType.Percentage:
      total -= (subTotal * parsedValues.offerValue) / 100;
      break;
    default:
      break;
  }

  const cgstAmount = isGstAllowed ? (total * parsedValues.cgstRate) / 100 : 0.0;
  const sgstAmount = isGstAllowed ? (total * parsedValues.sgstRate) / 100 : 0.0;

  let roundOff = 0.0;

  if (parsedValues.pointRedeem >= total) {
    parsedValues.pointRedeem = total;
    total = 0.0;
  } else {
    total = total + cgstAmount + sgstAmount - parsedValues.pointRedeem + parsedValues.deliveryCharge;
    roundOff = Math.round(total) - total;
    total += roundOff;
  }

  const duesAmount = isPartialBillEnabled ? total : 0.0;

  return {
    totalPrice: subTotal,
    finalPrice: total,
    pointRedeem: parsedValues.pointRedeem,
    cgstAmount,
    sgstAmount,
    roundOff,
    duesAmount
  };
};
  